<div class="card">
  <div class="card-header d-flex">
      <div class="row ">
        <div class="col-xl-12">
            <div class="row">
                <div class="col-md-7">
                  <h4>Onhold Transaction Report</h4>
                </div>
                <div class="col-md-2 mr-1">
                  <button type="button" [class]="type==='SCREENING' ? 'contact selected':'contact'" (click)="getDataByType('SCREENING')">Screening</button>
                </div>
                <div class="col-md-2">
                  <button type="button" [class]="type==='MONITORING' ? 'contact selected':'contact'" (click)="getDataByType('MONITORING')">Monitoring</button>
                </div>
            </div>
        </div>
    </div>
    </div>
  <div class="card-body m-0">
    <div class="row mb-2">
      <div class="col-xl-12">
        <div class="text-start">
          <button type="button" class="btn bg-danger-custom" (click)="isQuickFilter=!isQuickFilter">
            <i class="feather icon-filter me-2"></i>Filters
          </button>
          <button type="button" class="btn bg-danger-custom" *ngIf="permissions.includes('Search')" (click)="exportAsExcelFile()">
            <i class="feather icon-download me-2"></i>Export
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="isQuickFilter" class="row" style="min-height: 100px">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <label class="col-form-label" for="customerId">Customer ID</label>
              <input class="form-control" id="customerId" type="text" [(ngModel)]="customerId"
                placeholder="Enter Customer ID">
            </div>

            <div class="col-md-2">
              <label class="col-form-label" for="transactionId">Transaction ID</label>
              <input class="form-control" id="transactionId" [(ngModel)]="transactionId"  type="text"
                placeholder="Enter Transaction ID">
            </div>

            <div class="col-md-4">
              <div class="row">
                <div class="col-md-6">
                  <label class="col-form-label" for="searchFromDate">Select From Date</label>
                  <input #filSearchFromDate [(ngModel)]="searchFromDate" ngbDatepicker #d="ngbDatepicker"
                    class="form-control" id="searchFromDate" placeholder="yyyy-mm-dd" [maxDate]="maxDateFrom"
                    (click)="d.toggle()" (ngModelChange)="changeDate()" [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="col-md-6">
                  <label class="col-form-label" for="searchToDate">Select To Date</label>
                  <input #filSearchToDate [(ngModel)]="searchToDate" ngbDatepicker #d1="ngbDatepicker"
                    class="form-control" id="searchToDate" placeholder="yyyy-mm-dd" [maxDate]="maxDate"
                    [minDate]="minDate" (click)="d1.toggle()" (ngModelChange)="changeEndDate()"
                    [ngModelOptions]="{standalone: true}" />
                </div>
              </div>
            </div>

            <div class="col-sm-4 d-flex align-items-end">
              <button type="button" class="btn bg-danger-custom me-2" (click)="getOnHoldReport()" style="width: 100%;">
                <i class="feather icon-search me-2"></i>Search
              </button>
              <button (click)="resetFilter()" class="btn btn-secondary" type="button" style="width: 100%;">
                <i class="feather icon-refresh-cw me-2"></i>Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row mb-0" style="min-height: 380px">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
        <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
          (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
          (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
          (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef" [tooltipShowDelay]="0" [enableCellTextSelection]=true [rowData]="rowData"
          [rowModelType]="" [rowSelection]="'single'" style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>

    <div class="row mt-2" *ngIf="rowData.length">
      <div class="col-4 col-xs-4 d-flex">
        <select [(ngModel)]="pageRecords" (ngModelChange)="onPageSizeChanges($event)"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
        </select>
        <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
      </div>

      <div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="pageNumber" [boundaryLinks]="true"
          [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageRecords" [rotate]="false" [ellipses]="false"
          class="d-flex justify-content-end col-8 align-right" [directionLinks]="true">
        </ngb-pagination>
      </div>
    </div>

  </div>
</div>